export const Ornament = ({ className = "" }) => (
  <svg viewBox="0 0 40 26" className={`h-5 w-8 fill-gold ${className}`} aria-hidden="true">
    <path d="M20 1c3 6 3.4 10.5 0 15.5C16.6 11.5 17 7 20 1Z" />
    <path d="M20 16.5C14.5 10 8.5 11 5.5 15.5c4.2-.8 9 .4 14.5 3Z" />
    <path d="M20 16.5c5.5-6.5 11.5-5.5 14.5-1-4.2-.8-9 .4-14.5 3Z" />
    <rect x="17" y="18.5" width="6" height="1.6" />
    <path d="M20 20.5l2 2.5-2 2.5-2-2.5Z" />
  </svg>
);

export const RuleLabel = ({ children, className = "", light = false }) => (
  <p className={`flex items-center justify-center gap-4 font-caps text-[12px] tracking-[0.32em] uppercase ${light ? "text-gold" : "text-heritage"} ${className}`}>
    <span className="h-px w-12 bg-gradient-to-r from-transparent to-gold md:w-20" aria-hidden="true" />
    {children}
    <span className="h-px w-12 bg-gradient-to-l from-transparent to-gold md:w-20" aria-hidden="true" />
  </p>
);

export const SectionTitle = ({ eyebrow, title, children, light = false, className = "" }) => (
  <div className={`mx-auto max-w-4xl text-center ${className}`}>
    <Ornament className="mx-auto" />
    <RuleLabel className="mt-3" light={light}>{eyebrow}</RuleLabel>
    <h2 className={`mt-4 font-caps text-3xl leading-tight md:text-[2.7rem] ${light ? "text-ivory" : "text-heritage"}`}>{title}</h2>
    {children && <div className={`mx-auto mt-6 max-w-3xl text-lg leading-relaxed ${light ? "text-ivory/80" : "text-muted-ink"}`}>{children}</div>}
  </div>
);
